import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

axios.defaults.baseURL = process.env.REACT_APP_API_URL;

export const getAllClinicRadiologyServicesMaster = createAsyncThunk(
  "clinicRadiologyServicesMaster/getAllClinicRadiologyServicesMaster",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post("/clinicRadiologyServicesMaster/getAllClinicRadiologyServicesMaster",
        data,
        {
          headers: {
            "Content-Type": "application/json",
            token: data.token
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message)
    }
  }
);

const initialState = {
  radiologyServices: [],
  loading: false,
  searchMessage: null
};

const clinicRadiologyMasterSlice = createSlice({
  name: "clinicRadiologyServicesMaster",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllClinicRadiologyServicesMaster.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllClinicRadiologyServicesMaster.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.success) {
          state.radiologyServices = action.payload.result.list;
        }else{
          state.radiologyServices = [];
        }
      })
      .addCase(getAllClinicRadiologyServicesMaster.rejected, (state, action) => {
        state.loading = false;
      })
  },
});

export const { retsetUpdateRadiologyMaterMessage } = clinicRadiologyMasterSlice.actions;

export default clinicRadiologyMasterSlice.reducer;